import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabase';
import './Welcome.css';

function Welcome() {
    const navigate = useNavigate();

    useEffect(() => {
        const checkSession = async () => {
            const { data: { session } } = await supabase.auth.getSession();
            if (session) {
                navigate('/home');
            }
        };
        checkSession();
    }, [navigate]);

    return (
        <div className="welcome-screen">
            <div className="welcome-content">
                <div className="welcome-logo-wrap">
                    <svg width="64" height="64" viewBox="0 0 72 72" fill="none">
                        <rect width="72" height="72" rx="18" fill="#085041" />
                        <path d="M10 36C10 36 17 14 26 14C35 14 35 58 44 58C53 58 60 36 60 36" stroke="#9FE1CB" strokeWidth="3.5" strokeLinecap="round" />
                        <path d="M10 36C10 36 17 24 26 24C35 24 35 48 44 48C53 48 60 36 60 36" stroke="white" strokeWidth="1.5" strokeLinecap="round" opacity="0.35" />
                    </svg>
                    <div className="welcome-app-name">Vozoly</div>
                </div>
                <h1 className="welcome-title">
                    Learn a language the way it actually sticks
                </h1>
                <p className="welcome-subtitle">
                    Real topics, real conversations, and an AI that adapts
                    to your level — not the other way around.
                </p>
                <div className="welcome-actions">
                    <button className="btn-primary" onClick={() => navigate('/language')}>
                        Get started — it's free
                    </button>
                    <button className="btn-secondary" onClick={() => navigate('/signin')}>
                        I already have an account
                    </button>
                </div>
            </div>
        </div>
    );
}

export default Welcome;